import React, { useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import { MdDeleteForever } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUserAction,
  getAllUsersAction,
} from "../../redux/actions/adminAction";
import { Toaster, toast } from "react-hot-toast";

const AllUsers = () => {
  const { user } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const { users, message } = useSelector((state) => state.admin);

  // console.log(users?.users);
  useEffect(() => {
    if (message?.message) {
      toast.success(message?.message);
      dispatch({
        type: "clearMessage",
      });
    }
    dispatch(getAllUsersAction());
  }, [dispatch, message?.message]);

  // const users = [{
  //     _id: '64719588c10c3ee208baeccd',
  //     name: 'Suraj',
  //     email: 'suraj@gmail.com',
  //     role: 'admin',
  //     createdAt: '2023-05-27T05:27:46.602Z',
  // }]

  const deleteUserHandler = async(_id) => {
    console.log(_id);
    await dispatch(deleteUserAction(_id));
    dispatch(getAllUsersAction());

  };

  return (
    <>
    <Toaster/>
      <div className="grid grid-cols-5">
        <div className="">
          <AdminSidebar />
        </div>
        <div className="col-span-3 w-full py-20">
          <div className="w-full px-20">
            {/* form  */}
            <h1 className="font-semibold text-2xl my-6">Users</h1>
            <table className="table-auto	">
              <thead className="bg-[#F1F4FF]">
                <tr className="text-blue-700 border">
                  <th>#</th>

                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Created at</th>
                  <th>Subscription</th>

                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="bg-[#F1F4FF]">
                {users?.users && users?.users?.map((user, index) => (
                  <tr
                    className="border font-semibold text-gray-700"
                    key={user._id}
                  >
                    <td className="px-3">{index + 1}</td>
                    <td className="px-3">{user.name}</td>
                    <td className="px-3">{user.email}</td>
                    <td className="px-3">{user.role}</td>
                    <td className="px-3">{user.createdAt.split("T")[0]}</td>
                    <td className="px-3">{user?.subscription?.status}</td>

                    <td className="px-3 py-1">
                      <button
                        onClick={(e) => {
                          deleteUserHandler(user._id);
                        }}
                        className="bg-red-500 text-white px-2 py-2 rounded-sm"
                      >
                        <MdDeleteForever />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* profile  */}

        <div className=" bg-[#F6F6F6] text-center px-3 py-6 items-center text-[#141414] font-bold mx-2 text-base my-6">
          <h1 className="py-2">Profile</h1>
          <img
            alt="profile"
            className="h-[70px] rounded-full py-1 mx-auto"
            src={user?.avatar?.url}
          ></img>

          <div>
            <div>
              <h1 className="capitalize py-1 ">{user?.name}</h1>
              <h1 className="capitalize py-1">{user?.role} </h1>
            </div>

            <div>
              <h1 className="lowercase py-1">{user?.email} </h1>

              <h1 className="capitalize py-1 mb-4">
                {user?.subscription?.status}{" "}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllUsers;
